/*
创建者 魏强（2018.01.23）
提供 home api
包括
1首页
2首页菜单对应的各个页面的api
3商品店铺的搜索和列表
*/

import { post, post2 } from "utils/post";
/*
添加者 魏强(2018.01.23)
搜索商品
*/
export function goodsSearch(data) {
  return post2("/pc/goods/search", data);
}

/**
 * 查询搜索结果的树
 *
 * @param data
 * @returns {*}
 * @author 程楠
 */
export function goodsSearchTree(data) {
  return post2("/pc/goods/search4Tree", data);
}
// 推荐商品列表
export function recommendGoods(data) {
  return post2("/api/index/goods/banner", data);
}

/*
添加者 魏强(2018.2.25)
张全写的店铺搜索（PC端用这个）
*/
export function storeSearch(
  pageNo = 1,
  pageSize = 20,
  storeName,
  searchType
) {
  return post2("/pc/store/search", {
    pageNo,
    pageSize,
    storeName,
    searchType,
  });
}

/*
添加者 魏强(2018.01.23)
商品分类(通过父级ID来搜索商品分类，如果商品父级ID为0表示查询所有分类)
*/
export function getCatList(data) {
  return post2("/api/goodsCategory/categoryList", data);
}

/*
添加者 魏强(2018.01.24)
APP首页相关数据加载接口 此接口包含首页相关的开心快讯，精品速递，人气热推，猜你喜欢
*/
export function getIndexPageData() {
  return post2("/api/indexpage/index");
}

/*
添加者 魏强(2018.01.28)
PC首页数据
*/
export function pcIndexHome() {
  return post2("/pc/index/home");
}
/*
PC首页 全反专区/新人首单免费专区商品
6直营品牌专区首单免费商品7消费全返专区
*/
export function getMidAds(params = { sourceFlag: 6, pageSize: 12, pageNo: 1 }) {
  return post2("/api/index/allReturnZone", params);
}
/**
 * PC首页 各专区
 * 1首页推荐专区2每日上新3限时购4购物券专区精选5购物车为你推荐6推送专区8一县一品 9节日活动 10爆款专区商品
 *
 */
export function getCategory(
  params = { activeType: 6, pageSize: 12, pageNo: 1 }
) {
  return post2("/api/index/getSpecialPriceGoods", params);
}
/**
 * 非自营专区14
 *
 */
export function getNonDirect(params = { pageSize: 12, pageNo: 1 }) {
  return post2("/api/goods/searchNonDirectGoods", params);
}

/**
 * 免费换购专区商品列表 10
 *
 */
export function gettExchangeAds(params = { pageSize: 12, pageNo: 1 }) {
  return post2("/api/exchangeGoods/getExchangeGoods", params);
}

/*
PC首页 每日上新、热销榜获取数据
活动类型：1首页推荐专区2每日上新3限时购4现金券专区精选5购物车为你推荐6推送专区 8一村一品
*/
// actityType
export function activeGoods(
  params = { sourceFlag: 6, pageSize: 12, pageNo: 1, rowNum: 50 }
) {
  return post2("/api/index/menuActiveGoods", params);
}
export function getBannerSquare(data) {
  return post2("/pc/index/classification/zone", data);
}
/*
PC直营优品专区商品列表
*/
export function zyGoods() {
  return post2("/api/goods/zyIndexV2");
}
/*
PC首页分类板块获取数据
*/
export function typeHome(type = 1, pageNo = 1, pageSize = 9) {
  return post2("/api/index/classificationGoods", {
    classificationType: type,
    pageNo: pageNo,
    pageSize: pageSize,
  });
}

/*
添加者 魏强(2018.03.18)
PC顶部广告
acid:
1 首页顶部
39 特农鲜生顶部
40 特农鲜生 banner 上边覆盖的广告
41 特农鲜生 banner
*/
export function pcTopAdv(acid = 1) {
  return post2("/pc/index/header", { acid });
}

/*
添加者 魏强(2018.02.7)
还没逛够滚动加载的
type 0 or null 首页  ，1 自营首页
*/
export function continueShopping(pageNo = 1, pageSize = 15, type = 0) {
  return post2("/pc/index/notEnoughShopping", { pageNo, pageSize, type });
}

/*
添加者 魏强(2018.01.30)
中华老字号
*/
export function zhlzhIndex() {
  return post2("/api/goods/zhlzh");
}

/*
添加者 魏强(2018.01.30)
中华老字号-优选特推
*/
export function zhlzhGoodsYouXuan(pageNo) {
  let data = {
    pageNo,
    pageSize: 4,
    acId: 43,
  };
  return post2("/api/goods/zhlzhGoods", data);
}

/*
添加者 魏强(2018.01.30)
中华老字号-汇集珍品
*/
export function zhlzhGoodsZhenPing(pageNo) {
  let data = {
    pageNo,
    pageSize: 6,
    acId: 45,
  };
  return post("/api/goods/zhlzhGoods", data);
}

/*
添加者 魏强(2018.01.30)
农特生鲜
*/
export function getNtsxData(pageNo = 1, categoryId = 3, pageSize) {
  let data = {
    pageNo,
    pageSize,
    categoryId,
  };
  return post2("/api/goods/farmProduct/list", data);
}

/*
添加者 魏强(2018.02.1)
金牌网店首页页面
*/
export function personalGolden() {
  return post2("/pc/index/gold/shop");
}

/*
添加者 魏强(2018.02.5)
个人网店首页页面
*/
export function personal() {
  return post2("/pc/index/personal/shop");
}

/*
添加者 魏强(2018.02.8)
金牌网店和个人网店加载更多
参数：         个人 vs 金牌
store_type     1    vs 1
personType   1000 vs 3000
page           page从2开始,
pageSize
*/
//个人
export function personalStoreListPage(
  pageNo = 2,
  pageSize = 8,
  personType = 1000,
  storeType = 1
) {
  return post2("/pc/index/more/shops", {
    pageNo,
    pageSize,
    personType,
    storeType,
  });
}
//金牌
export function goldStoreListPage(
  pageNo = 2,
  pageSize = 8,
  personType = 3000,
  storeType = 4
) {
  return post2("/pc/index/more/shops", {
    pageNo,
    pageSize,
    personType,
    storeType,
  });
}
/*
获取银牌网店
*/
export function silverStoreListPage(data) {
  return post2("/api/store/storeList_type", data);
}
/*
添加者 魏强(2018.02.5)
企品牌首页页面
*/
export function pinpainew() {
  return post2("/pc/index/enterpriseBrand");
}

/*
添加者 魏强(2018.02.7)
企品牌首页 分页
*/
export function pinpainewPage(pageNo = 1, pageSize = 2, storeType = 2) {
  return post2("/pc/index/enterprise/brand/shop", { pageNo, pageSize, storeType });
}

/*
添加者 魏强(2018.02.8)
同城商家
*/
export function getLocalStoreList(data = {}) {
  return post2("/api/store/localStore/list", data);
}

/*
添加者 魏强(2018.02.8)
文章内容
*/

export function getArticleContent(articleId = 1) {
  return post2("/pc/index/article", { articleId, catId: "" });
}
/*中国地标优品 李伟(2018.06.02)*/
export function getAreaPage(data) {
  return post2("/pc/index/landmark/premium", data);
}

/*地区列表查询 李伟(2018.06.03)*/
export function getlandRegions(data) {
  return post2("/api/phone/largeArea/list", data);
}

/*地区商品列表查询 李伟(2018.06.03)*/
export function getQueryGoodsByProvince(data) {
  return post2("/api/goods/queryGoodsByProvince", data);
}

/*直营精品 李伟(2018.09.08)*/
export function getZgNiceGoods() {
  return post2("/pc/index/zgNiceGoods");
}

/*图片验证码 李伟(2018.11.02)*/
export function getVerifCode() {
  return post("/api/personal/getVerifyCode");
}
/*获取注册短信验证码 李伟(2018.11.02)*/
export function getRegisterCode(data) {
  return post2("/api/member/getVerificationCode", data);
}
/*注册 李伟*/
export function userRegister(data) {
  return post2("/api/phone/register", data);
}
/*获取活动页数据 李伟(2018.11.02)*/
export function getActivity() {
  return post2("/pc/index/activity");
}
/*获取搜索框相关提示信息 李伟(2019.01.19)*/
export function getSuggestGoodsList(data) {
  return post2("/api/goods/suggestGoodsList", data);
}



// WEBPACK FOOTER //
// ./src/api/home.js